import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from '../services/session';

export default class ExtractRoute extends Route {
  @service declare session: Session;
  @service declare router: RouterService;

  beforeModel() {
    if (!this.session.isAuthenticated) {
      this.router.transitionTo('login');
    }
  }
}
